module.exports = __webpack_public_path__ + "static/media/Spend_Controller.739953b1.png";